import React from 'react';
import DateUtils from '../../../lib/DateUtils';
import { RESOURCE_TYPE_DATA_MAP } from 'js/constants/resourceTypes';
import TagsView from '../../elements/tags/TagsView';
import TagsEditor from '../../elements/tags/TagsEditor';
import DocEditor from '../../elements/editors/DocEditor';
import DataMapSamplesContainer from '../DataMapSamplesContainer';

class DataMapCardOverviewTab extends React.Component {
  componentDidMount() {
    if (!this.props.preventInitialFetch) {
      this.props.fetchDataMapDoc(this.props.data.id);
    }
  }

  render() {
    const { data, readOnly, doc, isLoadingDoc, updateDataMapDoc } = this.props;
    const createdDate = DateUtils.convertDateStringToFormat(data.created_at);
    const lastUpdate = DateUtils.convertDateStringToFormat(data.updated_at);

    const tagsView =
      readOnly === true ? (
        <TagsView data={this.props.data} />
      ) : (
        <TagsEditor id={data.id} resourceType={RESOURCE_TYPE_DATA_MAP} />
      );

    return (
      <div className="tab-content preview-tab">
        <div className="detail-view-two-col">
          <div className="detail-view-main-col">
            {this.props.hideDocs ? null : (
              <DocEditor
                data={data}
                doc={doc}
                isLoading={isLoadingDoc}
                updateDoc={updateDataMapDoc}
              />
            )}
            <h2>Lookup Preview</h2>
            <DataMapSamplesContainer
              preventInitialFetch={this.props.preventInitialFetch}
              data={data}
            />
          </div>
          <div className="detail-view-side-col">
            <section style={{ padding: '0 16px' }}>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Type</div>
                  <div className="detail-value">
                    {data.data_set_id ? 'Dynamic' : 'Static'} Lookup
                  </div>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Lookup ID</div>
                  <div className="detail-value">{data.id}</div>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Record Count</div>
                  <div className="detail-value">
                    {data.map_entry_count !== 0 ? `${data.map_entry_count} Records` : ''}
                  </div>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Created On</div>
                  <div className="detail-value">{createdDate}</div>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Last Updated On</div>
                  <div className="detail-value">{lastUpdate}</div>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Tags</div>
                  <div className="detail-value">{tagsView}</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default DataMapCardOverviewTab;
